export const REFERRAL_STATUS = [
  {
    _id: 'active',
    label: 'Active',
  },
  {
    _id: 'called,calledLate',
    label: 'Called',
  },
  {
    _id: 'cancelled',
    label: 'Cancelled',
  },
  {
    _id: 'closed',
    label: 'Closed',
  },
  {
    _id: 'expired',
    label: 'Expired',
  },
  {
    _id: 'incomplete',
    label: 'Incomplete',
  },
  {
    _id: 'pending',
    label: 'Needs Approval',
  },
  {
    _id: 'future',
    label: 'Pending',
  },
  {
    _id: 'scheduled,scheduledLate',
    label: 'Scheduled',
  },
];

export const REFERRAL_STATUS_OUTBOUND = [
  {
    _id: 'active',
    label: 'Active',
  },
  {
    _id: 'called',
    label: 'Called',
  },
  {
    _id: 'cancelled',
    label: 'Cancelled',
  },
  {
    _id: 'closed',
    label: 'Closed',
  },
  {
    _id: 'expired',
    label: 'Expired',
  },
  {
    _id: 'incomplete',
    label: 'Incomplete',
  },
  {
    _id: 'future',
    label: 'Pending',
  },
  {
    _id: 'scheduled',
    label: 'Scheduled',
  },
];

export const APPOINTMENT_STATUS = [
  {
    _id: 'cancelled',
    label: 'Cancelled',
  },
  {
    _id: 'cancelled-noshow',
    label: 'No show',
  },
  {
    _id: 'confirmed',
    label: 'Confirmed',
  },
  {
    _id: 'confirmed-arrived',
    label: 'Arrived',
  },
  {
    _id: 'unconfirmed',
    label: 'Unconfirmed',
  },
];

export const STATUS_SOURCE = [
  {
    _id: 'luma',
    label: 'Luma Health',
  },
  {
    _id: 'integrator',
    label: 'Your EMR PM',
  },
];

export const APPOINTMENT_STATUS_REASON = [
  {
    _id: 'arrived',
    label: 'Arrived',
  },
  {
    _id: 'byOffer',
    label: 'By offer',
  },
  {
    _id: 'noshow',
    label: 'No Show',
  },
];

export const MODALITY = [
  {
    _id: 'office-visit',
    label: 'Office Visit',
  },
  {
    _id: 'telehealth',
    label: 'Telehealth',
  },
];

export const INSURANCE_VERIFICATION = [
  {
    _id: 'failed,inactive',
    label: 'Invalid Insurance Detected',
  },
  {
    _id: 'unknown',
    label: 'Insurances Not Checked Yet',
  },
  {
    _id: 'active',
    label: 'All Insurances Verified Active',
  },
];

export const ROLES = [
  {
    _id: 'admin',
    label: 'Admin',
  },
  {
    _id: 'manager',
    label: 'Manager',
  },
  {
    _id: 'subaccount,doctor',
    label: 'Sub Account',
  },
];

export const USER_STATUS = [
  {
    _id: 'active',
    label: 'Active',
  },
  {
    _id: 'pending',
    label: 'Pending',
  },
  {
    _id: 'suspended',
    label: 'Suspended',
  },
];

export const FORM_PROCESSING_STATUS = [
  {
    _id: 'open',
    label: 'Open',
  },
  {
    _id: 'inProgress',
    label: 'In Progress',
  },
  {
    _id: 'closed',
    label: 'Closed',
  },
];

export const SENT_TO_EHR_STATUS = [
  {
    _id: 'success',
    label: 'Sent',
  },
  {
    _id: 'failure',
    label: 'Error',
  },
  {
    _id: 'pending',
    label: 'Pending',
  },
  {
    _id: 'notApplicable',
    label: 'N/A',
  },
];

export const FACILITY_FEATURES_ENABLED = [
  {
    _id: 'followup',
    label: 'Custom Action',
  },
  {
    _id: 'feedback',
    label: 'Feedback',
  },
  {
    _id: 'referral',
    label: 'Referral',
  },
  {
    _id: 'reminder',
    label: 'Reminder',
  },
  {
    _id: 'scheduler',
    label: 'Scheduler',
  },
  {
    _id: 'cancellation',
    label: 'Waitlist',
  },
];

export const PROVIDER_FEATURES_ENABLED = FACILITY_FEATURES_ENABLED.concat([
  {
    _id: 'telehealth',
    label: 'Telehealth',
  },
]);

export const APPTTYPE_FEATURES_ENABLED = FACILITY_FEATURES_ENABLED.concat([
  {
    _id: 'cancellation.autoAddToWaitlist',
    label: 'Waitlist Auto-Add',
  },
]);

export const INTEGRATION_FLAGS = [
  {
    _id: 'visible',
    label: 'Visible',
  },
  {
    _id: 'hidden',
    label: 'Hidden',
  },
];

export const PROVIDERS_INTEGRATION_FLAGS = [
  {
    _id: 'visible',
    label: 'Visible',
  },
  {
    _id: 'hidden',
    label: 'Hidden',
  },
  {
    _id: 'schedulable',
    label: 'Schedulable',
  },
  {
    _id: 'referring',
    label: 'Referring',
  },
  {
    _id: 'rendering',
    label: 'Rendering',
  },
];

export const REMINDER_TYPE = [
  {
    _id: 'appointment',
    label: 'Appointment',
  },
  {
    _id: 'feedback',
    label: 'Feedback',
  },
  {
    _id: 'followup',
    label: 'Follow-up',
  },
  {
    _id: 'outboundReferral',
    label: 'Outbound Referral',
  },
  {
    _id: 'patientForm',
    label: 'Patient Form',
  },
  {
    _id: 'recall',
    label: 'Recall',
  },
  {
    _id: 'referral',
    label: 'Referral',
  },
  {
    _id: 'telehealth',
    label: 'Telehealth',
  },
  {
    _id: 'waitingRoom',
    label: 'Waiting Room',
  },
];

export const USER_TYPE = [
  {
    _id: 'staff',
    label: 'Staff',
  },
  {
    _id: 'doctor',
    label: 'Provider',
  },
];

export const CONSTANT_FILTERS: Record<string, Record<string, string>[]> = {
  referralStatus: REFERRAL_STATUS,
  referralStatusOutbound: REFERRAL_STATUS_OUTBOUND,
  apptStatus: APPOINTMENT_STATUS,
  statusSource: STATUS_SOURCE,
  facilityAttributes: INTEGRATION_FLAGS,
  apptTypeAttributes: INTEGRATION_FLAGS,
  providerAttributes: PROVIDERS_INTEGRATION_FLAGS,
  providerFeatures: PROVIDER_FEATURES_ENABLED,
  facilityFeatures: FACILITY_FEATURES_ENABLED,
  apptTypeFeatures: APPTTYPE_FEATURES_ENABLED,
  roles: ROLES,
  userType: USER_TYPE,
  status: USER_STATUS,
  formProcessingStatus: FORM_PROCESSING_STATUS,
  sentToEhrStatus: SENT_TO_EHR_STATUS,
  modality: MODALITY,
  reminderType: REMINDER_TYPE,
  insuranceVerification: INSURANCE_VERIFICATION,
};
